export default __webpack_public_path__ + "static/App Bars-fb0ac609329530e6c02535eb9a422716.png";